var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('FormWrapper',{attrs:{"type":"user"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('UserForm',{attrs:{"model":props.model,"validate":props.validate,"valid":props.valid}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }